<template>
	<v-img
		:src="src"
		:alt="computed_alt"
		v-bind="merged_attrs"
		v-on="$listeners"
	>
		<slot />
	</v-img>
</template>

<script>
export default {
	name: 'KImg',
	inheritAttrs: false,
	props: {
		src: {
			type: String,
			required: true,
		},
		alt: {
			type: String,
			default: '',
		},
		decorative: Boolean,
	},
	computed: {
		computed_alt() {
			return this.decorative ? '' : this.alt
		},
		merged_attrs() {
			const attrs = { ...this.$attrs }

			if (this.decorative) {
				// Decorative images should use alt="" so assistive tech skips repeated visual branding.
				attrs['aria-hidden'] = attrs['aria-hidden'] ?? 'true'
				attrs.role = attrs.role ?? 'presentation'
				return attrs
			}

			return attrs
		},
	},
	mounted() {
		this.warn_if_missing_text_alternative()
	},
	methods: {
		warn_if_missing_text_alternative() {
			if (this.decorative) return

			const has_text_alternative = Boolean(
				this.alt ||
				this.$attrs['aria-label'] ||
				this.$attrs['aria-labelledby']
			)

			if (!has_text_alternative) {
				console.warn('[KImg] Non-decorative images should provide alt text or an accessible label.')
			}
		},
	},
}
</script>
